const NON_BREAKING_SPACE = String.fromCharCode(160);

export const formatHotelNameWithStars = (hotelName: string, stars: number) => {
  const starsString = stars > 0 ? ` ${'*'.repeat(stars)}` : '';

  return `${hotelName}${starsString}`;
};

const hotelNameFromPackage = (name: string) =>
  name.slice(name.indexOf('•') + 1, name.length).trim();

export const formatHotelName = ({
  name,
  stars,
  aliasForUser,
  dayPackage = false,
}: {
  name: string;
  stars: number;
  aliasForUser?: string;
  dayPackage?: boolean;
}) => {
  const formattedStars =
    stars === 0 ? '' : `${NON_BREAKING_SPACE}${'*'.repeat(stars)}`;
  const hotelNameWithStars = `${hotelNameFromPackage(name)}${formattedStars}`;

  if (dayPackage) {
    return hotelNameWithStars;
  }

  const formattedAliasForUser = aliasForUser ? ` • ${aliasForUser}` : '';

  return `${hotelNameWithStars}${formattedAliasForUser}`;
};

export const packageTitle = ({
  experienceTitle,
  dayPackage,
  name,
  aliasForUser,
  stars = 0,
}: {
  dayPackage: boolean;
  name: string;
  experienceTitle?: string;
  aliasForUser?: string;
  stars?: number;
}) => {
  const formattedHotelName = formatHotelName({
    name,
    stars,
    aliasForUser,
    dayPackage,
  });

  return dayPackage && !!experienceTitle
    ? `${experienceTitle} • ${formattedHotelName}`
    : formattedHotelName;
};
